import "../../../../index75.css";
import { jsx as n } from "react/jsx-runtime";
import { ChevronUpLineIcon as i, ChevronDownLineIcon as m } from "@ifrc-go/icons";
import { _ as p } from "../../../../cs-piwRuCFZ.js";
import "../../../../type-BFTbooL7.js";
import d from "../../../Button/index.js";
const l = "_expand-button_1bf2c_1", f = "_icon_1bf2c_2", o = {
  expandButton: l,
  icon: f
};
function h(t) {
  const {
    className: a,
    row: e,
    onClick: c,
    expanded: r = !1,
    disabled: s
  } = t;
  return /* @__PURE__ */ n(
    d,
    {
      className: p(
        o.expandButton,
        a
      ),
      name: e,
      onClick: c,
      variant: "tertiary",
      disabled: s,
      children: r ? /* @__PURE__ */ n(i, { className: o.icon }) : /* @__PURE__ */ n(m, { className: o.icon })
    }
  );
}
export {
  h as default
};
